export const getPercentageHelper = (value: number, fullValue: number): number =>
  (value / fullValue) * 100;
